import React from 'react';
import FormField from '../FormField';

export default function HabitacaoSeguranca() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual da habitação e da segurança pública no município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="habitacao_seguranca_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual da habitação e da segurança pública, considerando déficit habitacional, regularização fundiária, habitação social, expansão urbana, Guarda Municipal, Defesa Civil, videomonitoramento e iluminação pública"
          helpText="Considere déficit habitacional, regularização fundiária, habitação social, expansão urbana, Guarda Municipal, Defesa Civil, videomonitoramento e iluminação pública"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="habitacao_seguranca_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como déficit habitacional, famílias ou áreas em regularização, unidades de habitação social, efetivo da Guarda e Defesa Civil, câmeras e cobertura de iluminação, sempre com ano de referência"
          helpText="Déficit habitacional, famílias ou áreas em regularização, unidades de habitação social, efetivo da Guarda e Defesa Civil, câmeras e cobertura de iluminação, sempre com ano de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="habitacao_seguranca_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados nas áreas de habitação e segurança pública"
          helpText="Principais problemas identificados nas áreas de habitação e segurança pública"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="habitacao_seguranca_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas para habitação, regularização, defesa civil, videomonitoramento, iluminação e demais ações de segurança"
          helpText="Considere habitação, regularização, defesa civil, videomonitoramento, iluminação e demais ações de segurança"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao7"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao7"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
